import React, { useEffect, useState, useRef } from 'react';
import './App.css';
//import './App-New.css';
import axios from 'axios';
import { BASE_URL } from '../pages/constants';
import MainPanel from './MainPanel';
import { useNavigate, Link } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import * as Fa6Icons from 'react-icons/fa6';
import * as BsIcons from 'react-icons/bs';
import * as GrIcons from 'react-icons/gr';
import * as TbIcons from 'react-icons/tb';
import * as HiIcons from 'react-icons/hi';
import * as Hi2Icons from 'react-icons/hi2';
import * as BiIcons from 'react-icons/bi';
import * as CgIcons from 'react-icons/cg';
import * as MdIcons from 'react-icons/md';
import * as CiIcons from 'react-icons/ci';
import * as RiIcons from "react-icons/ri";
import { ImUserTie } from "react-icons/im";
import * as Io5Icons from "react-icons/io5";
import * as GiIcons from "react-icons/gi";
import { FaHome } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DashboardPage = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [societyName, setSocietyName] = useState('');
  const [menuItems, setMenuItems] = useState([]);
  const [openMenus, setOpenMenus] = useState({});
  const fetchedRef = useRef(false); // 🚫 Prevent double API call

  const iconMap = {
    ...FaIcons,
    ...Fa6Icons,
    ...BsIcons,
    ...GrIcons,
    ...TbIcons,
    ...HiIcons,
    ...Hi2Icons,
    ...BiIcons,
    ...CgIcons,
    ...MdIcons,
    ...CiIcons,
    ...RiIcons,
    ...Io5Icons,
    ...GiIcons,
    ImUserTie,

  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUserName = localStorage.getItem('user_name');
    const storedSocietyName = localStorage.getItem('society_name');
    setSocietyName(storedSocietyName);

    if (!token) return navigate('/');
    if (storedUserName) setUserName(storedUserName);
  
    // Sidebar menu localStorage se lo
    const cachedMenu = localStorage.getItem('user_menu');
    if (cachedMenu) {
      setMenuItems(JSON.parse(cachedMenu));
    } else {
      setMenuItems([]); // Agar menu nahi mila
    }
  }, [navigate]);
  // ...existing code...

  useEffect(() => {
    const handleClickOutside = (e) => {
      const sidebar = document.querySelector('.sidebar');
      const toggleBtn = document.querySelector('.togglebtn');
      if (
        isSidebarOpen &&
        sidebar &&
        !sidebar.contains(e.target) &&
        toggleBtn &&
        !toggleBtn.contains(e.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSidebarOpen]);

  const handleLogout = async () => {
    const token = localStorage.getItem('token');
  
    try {
      await axios.post(`${BASE_URL}/api/logout`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
  
      // Clear local storage after successful logout
      localStorage.removeItem('token');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_menu');
      localStorage.removeItem('session_start');
      localStorage.removeItem('session_expiry');
  
      navigate('/');
      toast.info('Logout successful');
      //window.alert('Logout successful');
    } catch (err) {
      console.error('Logout error:', err);
      toast.warning('Failed to Logout');
      //window.alert('Failed to logout');
    }
  };
  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const toggleMenu = (id, type, parentId) => {
    setOpenMenus(prev => {
      // If toggling a main menu, close all except this one and keep sub-menus state
      if (type === 'Menu') {
        // Keep only sub-menu open states for this menu
        const newState = {};
        // Copy sub-menu open states under this menu
        Object.keys(prev).forEach(key => {
          if (menuItems.find(mi => mi.menu_item_id === key && mi.parent_id === id && mi.menu_type === 'Sub-Menu')) {
            newState[key] = prev[key];
          }
        });
        // Toggle main menu
        newState[id] = !prev[id];
        return newState;
      }
      // For sub-menus, just toggle their own state
      return {
        ...prev,
        [id]: !prev[id]
      };
    });
  };

  const renderMenu = (items, parentId = '0') => {
    return items
      .filter(item => item.parent_id === parentId && item.menu_type === 'Menu')
      .map(menu => {
        const Icon = iconMap[menu.icon] || FaIcons.FaFolder;
        const subMenus = items.filter(i => i.parent_id === menu.menu_item_id && i.menu_type === 'Sub-Menu');
        const pages = items.filter(i => i.parent_id === menu.menu_item_id && i.menu_type === 'Page');
        const isOpen = openMenus[menu.menu_item_id];

        return (
          <div className="menu-item" key={menu.menu_item_id}>
            <div className="menu-title" 
                    onClick={() => {if (subMenus.length === 0 && pages.length === 0 && menu.file_name) {
                                        navigate(menu.file_name);
                                    } else {
                                          toggleMenu(menu.menu_item_id, "Menu");
                                    }
              }}>
              {/* commented to test Home click option */}
            {/* <div className="menu-title" onClick={() => toggleMenu(menu.menu_item_id, 'Menu')}> */}
              <Icon style={{ fontSize: '20px', marginRight: '10px' }} />
              {menu.menu_name}
              {isOpen ? <FaIcons.FaAngleDown /> : <FaIcons.FaAngleRight />}
            </div>

            {isOpen && (
              <div className="submenu">
                {/* Render direct pages */}
                {pages.map(page => {
                  const PageIcon = iconMap[page.icon] || FaIcons.FaFileAlt;
                  return (
                    <div className="submenu-item" key={page.menu_item_id}>
                      {/* <Link to={page.file_name} className="sidebar_link"> */}
                      <Link to={page.file_name} className="sidebar_link" onClick={() => setIsSidebarOpen(false)}>
                        <PageIcon style={{ marginRight: '8px' }} />
                        {page.menu_name}
                      </Link>
                    </div>
                  );
                })}

                {/* Render submenus and their pages */}
                {subMenus.map(sub => {
                  const SubIcon = iconMap[sub.icon] || FaIcons.FaAngleRight;
                  const subOpen = openMenus[sub.menu_item_id];
                  const subPages = items.filter(
                    p => p.parent_id === sub.menu_item_id && p.menu_type === 'Page'
                  );

                  return (
                    <div key={sub.menu_item_id}>
                      <div className="submenu-title" onClick={() => toggleMenu(sub.menu_item_id, 'Sub-Menu', menu.menu_item_id)}>
                        <SubIcon style={{ marginRight: '8px' }} />
                        {sub.menu_name}
                        {subOpen ? <FaIcons.FaAngleDown /> : <FaIcons.FaAngleRight />}
                      </div>
                      {subOpen && (
                        <div className="submenu">
                          {subPages.map(sp => {
                            const SubPageIcon = iconMap[sp.icon] || FaIcons.FaFileAlt;
                            return (
                              <div className="submenu-item" key={sp.menu_item_id}>
                                {/* <Link to={sp.file_name} className="sidebar_link">
                                  <SubPageIcon style={{ marginRight: '8px' }} />
                                  {sp.menu_name}
                                </Link> */}
                                <Link
                                  to={sp.file_name}
                                  className="sidebar_link"
                                  onClick={() => setIsSidebarOpen(false)}
                                >
                                  <SubPageIcon style={{ marginRight: '8px' }} />
                                  {sp.menu_name}
                                </Link>

                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      });
  };

  return (
    <div className="top">
      {/* <div className="d-flex justify-content-between">
        <button className="togglebtn" onClick={toggleSidebar}>
          {isSidebarOpen ? '✖' : '☰'}
        </button>
        <h4 className="pt-2">{societyName}</h4>
        <div className="pt-1 d-flex align-items-center gap-3">
          <span className="bg-light text-dark px-3 py-1 rounded-pill shadow-sm fw-semibold">
            {userName}
          </span>
          <button className="btn btn-outline-light d-flex align-items-center" onClick={handleLogout}>
            <FiLogOut size={20} />
            <span className="ms-1 d-none d-md-inline">LogOut</span>
          </button>
        </div>
      </div> */}

      <div className="d-flex justify-content-between align-items-center">

        {/* Left side: Menu + Home */}
        <div className="d-flex align-items-center">
          <button className="togglebtn" onClick={toggleSidebar}>
            {isSidebarOpen ? '✖' : '☰'}
          </button>

          <button
            className="homebtn"
            onClick={() => {
              setIsSidebarOpen(false);
              navigate("/dashboard");
            }}
            title="Home"
          > 
            <FaIcons.FaHome />
          </button>
        </div>

        {/* Center: Society Name */}
        <h4 className="pt-2 mb-0">{societyName}</h4>

        {/* Right side: User + Logout */}
        <div className="pt-1 d-flex align-items-center gap-3">
          <span className="bg-light text-dark px-3 py-1 rounded-pill shadow-sm fw-semibold">
            {userName}
          </span>

          <button
            className="btn btn-outline-light d-flex align-items-center"
            onClick={handleLogout}
          >
            <FiLogOut size={20} />
            <span className="ms-1 d-none d-md-inline">LogOut</span>
          </button>
        </div>

      </div>

      <div className={`overlay ${isSidebarOpen ? 'active' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>

      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="menu">{renderMenu(menuItems)}</div>
      </div>

      <div className="main">
        <MainPanel page="dashboard" />
      </div>
    </div>
  );
};

export default DashboardPage;
